/**
 * 全站路由配置
 *
 * 建议:
 * 1. 代码中路由统一使用name属性跳转(不使用path属性)
 */
import Vue from 'vue'
import Router from 'vue-router'
import {isURL} from '@/utils/validate'
import loginHttp, {checkLogin, logout} from '@/utils/login'
import httpRequest from '@/utils/httpRequest'

Vue.use(Router)
// 开发环境不使用懒加载, 因为懒加载页面太多的话会造成webpack热更新太慢, 所以只有生产环境使用懒加载
const _import = require('./import-' + process.env.NODE_ENV)

const skipLoadMenusRoutes = [
    { 'name': 'demo', path: '/demo' }
]
/**
 * 重写路由的push方法
 */
const routerPush = Router.prototype.push
const addRouter = Router.prototype.addRouter
Router.prototype.push = function push(location) {
    return routerPush.call(this, location).catch(error => error)
}

const mainRoutes = {
    path: '/',
    component: _import('main'),
    name: 'main',
    redirect: { name: 'home' },
    meta: { title: '主入口整体布局' },
    children: [
        // 通过meta对象设置路由展示方式
        // 1. isTab: 是否通过tab展示内容, true: 是, false: 否
        // 2. iframeUrl: 是否通过iframe嵌套展示内容, '以http[s]://开头': 是, '': 否
        // 提示: 如需要通过iframe嵌套展示内容, 但不通过tab打开, 请自行创建组件使用iframe处理!
      {
        path: '/home',
        component: _import('common/home'),
        name: 'home',
        meta: { title: '首页', isTab: false},
      },
      { path: '/home_link/config', component: _import('common/homeLinkConfig'), name: 'home_link_config', meta: {single:true, title: '首页链接配置',hideSiderBar: true, isTab: false } },
       // 数据权限配置
      { path: '/dataPermission/config', component: _import('common/dataPermissionConfig'), name: 'dataPermission-config', meta: {single:true, title: '数据权限配置', isTab: true } },
      //元数据列表&详页
        { path: '/metadata/table_list', component: _import('modules/metadata/table_list'), name: 'metadata_table_list', meta: {single:true, title: '元数据管理', isTab: true } },
        { path: '/metadata/table_config/:id', component: _import('modules/metadata/table_config'), name: 'metadata_table_config', meta: {single:true, title: '元数据配置',parentMenuKey:'/metadata/table_list', isTab: true } },
        //自定义表单管理列表&详页
        { path: '/customfm/detailconfig/:id', component: _import('modules/customform/detail_config'), name: 'customform_detail_config', meta: {single:true, title: '自定义表单明细配置', isTab: true,parentMenuKey:'/customfm/list' } },
        { path: '/customfm/listconfig/:id', component: _import('modules/customform/list_config'), name: 'customform_list_config', meta: {single:true, title: '列表表单配置', isTab: true,parentMenuKey:'/customfm/list' } },
        { path: '/customfm/list', component: _import('modules/customform/list'), name: 'customform_list', meta: {single:true, title: '自定义表单管理', isTab: true } },
        { path: '/customfm/edit', component: _import('modules/customform/edit'), name: 'customform_edit', meta: {single:true, title: '自定义表单配置', isTab: true,parentMenuKey:'/customfm/list' } },
        { path: '/bid_check_config/list', component: _import('modules/customform/bid_check_config_list'), name: 'bid_check_config_list', meta: {single:true, title: '开评标监督检查项配置', isTab: true } },

        //数据库连接配置
        { path: '/datasourceconfig/list', component: _import('modules/datasourceconfig/list'), name: 'datasourceconfig_list', meta: {single:true, title: '数据源列表', isTab: true } },
        { path: '/datasourceconfig/edit', component: _import('modules/datasourceconfig/edit'), name: 'datasourceconfig_edit', meta: {single:true, title: '数据源详情', isTab: true,parentMenuKey:'/datasourceconfig/list' } },
        { path: '/test/video', component: _import('demo/video_demo'), name: 'test_video', meta: {single:true, title: '视频直播测试', isTab: true } },
        // 场地摄像头配置
        { path: '/cameras_config/list', component: _import('modules/config/cameras_config_list'), name: 'cameras_config_list', meta: {single:true, title: '场地摄像头配置', isTab: true } },
        // 预警规则配置
        { path: '/warnItem/warn_items_list', component: _import('modules/warnItem/warn_items_list'), name: 'warn_items_list', meta: {single:true, title: '项目三级预警规则', isTab: true } },
        //
        { path: '/warn_record/list', component: _import('modules/warnrecord/warn_record_list'), name: 'warn_record_list', meta: {single:true, title: '项目参数流程预警', isTab: true } },
        { path: '/warn_record/detail', component: _import('modules/warnrecord/warn_record_detail'), name: 'warn_record_detail', meta: {single:true, title: '项目参数流程预警详页',parentMenuKey:'/warn_record/list', isTab: true } },
        //
        { path: '/early_warning/list', component: _import('modules/warnrecord/early_warning_list'), name: 'early_warning_list', meta: {single:true, title: '项目风险预警', isTab: true } },
        { path: '/early_warning/detail', component: _import('modules/warnrecord/early_warning_detail'), name: 'early_warning_detail', meta: {single:true, title: '项目风险预警详页',parentMenuKey:'/early_warning/list', isTab: true } },
        //
        { path: '/warn_record_activity/list', component: _import('modules/warnrecord/warn_record_activity_list'), name: 'warn_record_activity_list', meta: {single:true, title: '交易主体活动预警', isTab: true } },
        { path: '/warn_record_activity/detail', component: _import('modules/warnrecord/warn_record_activity_detail'), name: 'warn_record_activity_detail', meta: {single:true, title: '交易主体活动预警详页',parentMenuKey:'/warn_record_activity/list', isTab: true } },
        //
        { path: '/warn_record_ability/list', component: _import('modules/warnrecord/warn_record_ability_list'), name: 'warn_record_ability_list', meta: {single:true, title: '代理业务能力预警', isTab: true } },
        { path: '/warn_record_efficiency/list', component: _import('modules/warnrecord/warn_record_efficiency_list'), name: 'warn_record_efficiency_list', meta: {single:true, title: '项目服务效能预警', isTab: true } },

        // { path: '/warnrecord/warn_record_form', component: _import('modules/warnrecord/warn_record_form'), name: 'warn_record_form', meta: {single:true, title: '交易数据查看', isTab: true } },
        // 业务流程节点配置
        { path: '/flownode_config/list', component: _import('modules/config/flownode_config_list'), name: 'flownode_config_list', meta: {single:true, title: '业务流程节点配置列表', isTab: true } },
        { path: '/flownode_config/detail', component: _import('modules/config/flownode_config_detail'), name: 'flownode_config_detail', meta: {single:true, title: '业务流程节点配置详页',parentMenuKey:'/flownode_config/list', isTab: true } },
        { path: '/flownode_config/view', component: _import('modules/config/flownode_config_view'), name: 'flownode_config_view', meta: {single:true, title: '业务流程节点配置详页',parentMenuKey:'/flownode_config/list', isTab: true } },


        // 评标专家监管
        { path:'/experts/evalList',component:_import('modules/experts/evalList'),name:'experts_evalList', meta: {single:true,title: '专家评审记录列表', isTab: true}},

        { path:'/experts/detail',component:_import('modules/experts/detail'),name:'experts_detail', meta: {single:true,title: '专家评审记录列表详情',parentMenuKey:'/experts/evalList', isTab: true}},

        // 评标专家监管
        { path:'/experts/eval_archives/list',component:_import('modules/experts/evalArchivesList'),name:'eval_archives_list', meta: {single:true,title: '专家评价档案列表', isTab: true}},
        { path:'/experts/eval_archives/daily_detail',component:_import('modules/experts/dailyDetail'),name:'eval_daily_detail', meta: {single:true,title: '评标专家日常评价详页',parentMenuKey:'/experts/eval_archives/list', isTab: true}},
        { path:'/experts/eval_archives/annual_detail',component:_import('modules/experts/annualDetail'),name:'eval_annual_detail', meta: {single:true,title: '评标专家年度考核详页', parentMenuKey:'/experts/eval_archives/list',isTab: true}},
         // experts/config 评标专家配置
        { path:'/experts_eval_item/config',component:_import('modules/experts/config/index'),name:'eval_config', meta: {single:true,title: '评标专家监管配置',isTab: true}},

        // 开评标监管人员登记
        { path:'/openevalpersonregister/list',component:_import('modules/personRegister/personRegisterList'),name:'personRegister_list', meta: {single:true,title: '开评标监管人员登记', isTab: true}},
        // 开评标监管人员登记查看
        { path: '/openevalpersonregister/view', component: _import('modules/personRegister/personRegisterView'), name: 'personRegister_view', meta: {single:true, title: '监管人员登记详页',parentMenuKey:'/openevalpersonregister/list', isTab: true } },
        // 开评标监管人员登记新增和修改
        { path: '/openevalpersonregister/edit', component: _import('modules/personRegister/personRegisterEdit'), name: 'personRegister_edit', meta: {single:true, title: '监管人员登记编辑页',parentMenuKey:'/openevalpersonregister/list', isTab: true } },

        //在线举报信息查看
        { path: '/complaintReporting/list',component:_import('modules/complaintreporting/reporting/index'),name:'complaint_reporting_list', meta: {single:true,title: '在线举报信息', isTab: true}},
        { path: '/complaintReporting/view',component:_import('modules/complaintreporting/reporting/view'),name:'complaint_reporting_view', meta: {single:true,title: '在线举报信息详页',parentMenuKey:'/complaintReporting/list', isTab: true}},

        //项目监管受理
        { path:'/businessflowWitness/list', component: _import('modules/businessflowWitness/index'), name: 'busWitness_list', meta: {single:true, title: '项目备案监管', isTab: true } },
        { path:'/businessflowWitness/detail',component:_import('modules/businessflowWitness/detail'),name:'busWitness_detail', meta: {single:true,title: '项目备案监管详页', parentMenuKey:'busWitness_list',isTab: true}},
        { path:'/businessflowWitness/add', component: _import('modules/businessflowWitness/add'), name: 'busWitness_add', meta: {single:true, title: '开评标过程备案',parentMenuKey:'/businessflowWitness/list', isTab: true } },

        //传输数据日志
        { path: '/sysTransLogs/list', component: _import('modules/logs/sysTransLogs'), name: 'SysTransLogsTable', meta: {title: '传输数据日志列表', isTab: true}},

        //项目全生命周期监管
        { path: '/businessWitnessHis', component: _import('modules/businessWitnessHis/index'), name: 'businessWitnessHis', meta: {single:true, title: '项目全生命周期监管', isTab: true } },
        { path:'/businessWitnessHis/detail',component:_import('modules/businessWitnessHis/detail'),name:'businessWitnessHis_detail', meta: {single:true,title: '项目全生命周期监管详页', parentMenuKey:'/businessWitnessHis',isTab: true}},

        //招标计划监管
        { path: '/biddingPlanWitnessHis', component: _import('modules/biddingPlanWitnessHis/index'), name: 'biddingPlanWitnessHis', meta: {single:true, title: '招标计划监管', isTab: true } },

        //执法检查人员名录
        { path: '/lawEnforcement/list', component: _import('modules/doubleRandom/lawEnforcement/lawEnforcementList'), name: 'lawEnforcementList', meta: {single:true, title: '执法检查人员名录', isTab: true } },
        { path: '/lawEnforcement/detail', component: _import('modules/doubleRandom/lawEnforcement/lawEnforcement_detail'), name: 'lawEnforcement_detail', meta: {single:true, title: '执法检查人员名录详页',parentMenuKey:'/lawEnforcement/list', isTab: true } },
        { path: '/lawEnforcement/view', component: _import('modules/doubleRandom/lawEnforcement/lawEnforcement_view'), name: 'lawEnforcement_view', meta: {single:true, title: '执法检查人员名录查看',parentMenuKey:'/lawEnforcement/list', isTab: true } },


        //双随机项目检查结果录入
        { path: '/inspectionResult/entry_list', component: _import('modules/doubleRandom/inspectionResult/inspectionResultEntry'), name: 'inspectionResultEntry', meta: {single:true, title: '双随机项目检查结果录入', isTab: true } },
        { path: '/inspectionResult/entry_detail', component: _import('modules/doubleRandom/inspectionResult/inspectionResult_detail'), name: 'inspectionResult_detail', meta: {single:true, title: '双随机项目检查结果录入详页',parentMenuKey:'/inspectionResult/entry_list', isTab: true } },

        //执法检查结果公告发布
        { path: '/result_notice/list', component: _import('modules/doubleRandom/resultNotice/list'), name: 'resultNotice_list', meta: {single:true, title: '执法检查结果公告发布', isTab: true } },
        { path: '/result_notice/detail', component: _import('modules/doubleRandom/resultNotice/detail'), name: 'resultNotice_detail', meta: {single:true, title: '执法检查结果公告发布详页',parentMenuKey:'/result_notice/list', isTab: true } },

        // 双随机配置项
        { path: '/extractConfigurationItem/list', component: _import('modules/extractConfigurationItem/extractConfigurationItemList'), name: 'extractConfigurationItem', meta: {single:true, title: '项目双随机抽取配置', isTab: true } },
        { path: '/extractConfigurationItem/detail', component: _import('modules/extractConfigurationItem/extractConfigurationItemDetail'), name: 'extractConfigurationItem_detail', meta: {single:true, title: '项目双随机抽取配置详页',parentMenuKey:'/extractConfigurationItem/list', isTab: true } },


        //专家抽取监管
        { path: '/traddingWitness/expertWitness_his/list', component: _import('modules/traddingWitness/expertWitness/list'), name: 'expertWitness_list', meta: {single:true, title: '专家抽取监管列表',isTab: true } },
        { path: '/traddingWitness/expertWitness_his/view', component: _import('modules/traddingWitness/expertWitness/view'), name: 'expertWitness_view', meta: {single:true, title: '专家抽取监管详页', parentMenuKey:'/traddingWitness/expertWitness_his/list', isTab: true } },
        { path: '/traddingWitness/expertWitness/detail', component: _import('modules/traddingWitness/expertWitness/detail'), name: 'expertWitness_detail', meta: {single:true, title: '专家抽取实时监管', parentMenuKey:'/traddingWitness/expertWitness_his/list', isTab: true } },

        //开评标监督记录
        { path: '/traddingWitness/openBidWitness_his/list', component: _import('modules/traddingWitness/openBidWitness/list'), name: 'openBidAndEstimateWitness_list', meta: {single:true, title: '开评标监督记录', isTab: true } },
        // 评标记录
        { path: '/traddingWitness/openBidWitness_his/eval_view', component: _import('modules/traddingWitness/estimateBidWitness/view'), name: 'estimateBidWitness_view', meta: {single:true, title: '评标监管详页',parentMenuKey:'/traddingWitness/openBidWitness_his/list',  isTab: true } },
        // 开标记录
        { path: '/traddingWitness/openBidWitness_his/open_view', component: _import('modules/traddingWitness/openBidWitness/view'), name: 'openBidWitness_view', meta: {single:true, title: '开标监督详页',parentMenuKey:'/traddingWitness/openBidWitness_his/list',  isTab: true } },

        // 评标详页 （实时监管）
        { path: '/traddingWitness/openBidWitness/eval_detail', component: _import('modules/traddingWitness/estimateBidWitness/detail'), name: 'estimateBidWitness_detail', meta: {single:true, title: '评标实时监管', parentMenuKey:'/traddingWitness/openBidWitness_his/list',isTab: true } },
        // 开标详页 （实时监管）
        { path: '/traddingWitness/openBidWitness/open_detail', component: _import('modules/traddingWitness/openBidWitness/detail'), name: 'openBidWitness_detail', meta: {single:true, title: '开标实时监管',parentMenuKey:'/traddingWitness/openBidWitness_his/list', isTab: true } },
 
        // 门禁配置表
        { path: '/guard_config/list', component: _import('modules/config/guard_config_list'), name: 'guard_config_list', meta: {single:true, title: '门禁配置列表', isTab: true } },
        { path: '/guard_config/detail', component: _import('modules/config/guard_config_detail'), name: 'guard_config_detail', meta: {single:true, title: '门禁配置详页',parentMenuKey:'/guard_config/list', isTab: true } },
        { path: '/guard_config/view', component: _import('modules/config/guard_config_view'), name: 'guard_config_view', meta: {single:true, title: '门禁配置详页',parentMenuKey:'/guard_config/list', isTab: true } },

        //实时门禁出入监管
        { path: '/realtime_guardwitness_list', component: _import('modules/guardWitness/realtime_guardwitness_list'), name: 'realtime_guardwitness_list', meta: { single:true,title: '门禁实时出入记录', isTab: true } },

        //门禁出入记录
        { path: '/guardWitness/guard_witness_list', component: _import('modules/guardWitness/guard_witness_list'), name: 'guard_witness_list', meta: { single:true,title: '门禁历史出入记录',parentMenuKey:'/realtime_guardwitness_list', isTab: true } },
        { path: '/guardWitness/guard_witness_view', component: _import('modules/guardWitness/guard_witness_view'), name: 'guard_witness_view', meta: { single:true,title: '门禁出入记录详页',parentMenuKey:'/realtime_guardwitness_list', isTab: true } },

        //监管规则设置
        { path: '/witnessrule_config/list', component: _import('modules/config/witnessrule_config_list'), name: 'witnessrule_config_list', meta: { single:true,title: '监管规则设置列表', isTab: true}},


        // 移动轨迹监管
        // 实时轨迹监管
        { path: '/track_witness', component: _import('modules/movingTrail/track_witness'), name: 'track_witness', meta: { single:true,title: '专家实时活动轨迹', isTab: true,iframeUrl:"", } },
        // 历史轨迹查阅
        { path: '/track_history', component: _import('modules/movingTrail/track_history'), name: 'track_history', meta: { single:true,title: '专家历史活动轨迹', isTab: true,iframeUrl:"", } },
        // 人员轨迹追溯
        { path: '/track_retrospect', component: _import('modules/movingTrail/track_retrospect'), name: 'track_retrospect_list', meta: { single:true,title: '人员轨迹追溯', isTab: true, iframeUrl:"", } },
        // 胸牌绑定
        { path: '/breastpiece_bind/list', component: _import('modules/movingTrail/breastpiece_bind_list'), name: 'breastpiece_bind_list', meta: { single:true,title: '胸牌绑定', isTab: true } },


        //监管数据出证申请
        {path: '/catequest_base/list', component: _import('modules/catequest/catequest_base_list'), name: 'catequest_base_list', meta: {single:true,title: '监管数据出证申请列表', isTab: true}},
        {path: '/catequest_base/detail', component: _import('modules/catequest/catequest_base_detail'), name: 'catequest_base_detail', meta: {single:true,title: '监管数据出证申请详页',parentMenuKey:'/catequest_base/list', isTab: true}},

        //监管数据出证受理
        {path: '/cateout_quest/list', component: _import('modules/catequest/cateout_quest_list'), name: 'cateout_quest_list', meta: {single:true,title: '监管数据出证受理列表', isTab: true}},
        {path: '/cateout_quest/detail', component: _import('modules/catequest/cateout_quest_detail'), name: 'cateout_quest_detail', meta: {single:true,title: '监管数据出证受理详页',parentMenuKey:'/cateout_quest/list', isTab: true}},
        //制作监管书
        {path: '/cateout_quest/make_catequest_note', component: _import('modules/catequest/make_catequest_note'), name: 'make_catequest_note', meta: {single:true,title: '制作监管书页', isTab: true}},
        //监管书下载
        {path: '/cateout_quest/download_catequest_note', component: _import('modules/catequest/download_catequest_note'), name: 'download_catequest_note', meta: {single:true,title: '监管书下载页', isTab: true}},
        //交易监管书列表
        {path: '/catequest_note/list', component: _import('modules/catequest/catequest_note_list'), name: 'catequest_note_list', meta: {single:true,title: '交易监管书', isTab: true}},
        //交易监管书详页
        {path: '/catequest_note/detail', component: _import('modules/catequest/catequest_note_detail'), name: 'catequest_note_detail', meta: {single:true,title: '交易监管书详页',parentMenuKey:'/catequest_note/list', isTab: true}},


        //交易活动监管-项目交易活动信息
        {path: '/trading_activity/list', component: _import('modules/tradingActivity/trading_activity_list'), name: 'trading_activity_list', meta: {single:true,title: '项目交易活动信息列表', isTab: true}},
        {path: '/trading_activity/detail', component: _import('modules/tradingActivity/trading_activity_detail'), name: 'trading_activity_detail', meta: {single:true,title: '项目交易活动信息详页',parentMenuKey:'/trading_activity/list', isTab: true}},

        //交易活动监管-人员面部信息库
        {path: '/facial_info/list', component: _import('modules/facialInfo/facial_info_list'), name: 'facial_info_list', meta: {single:true,title: '人员面部信息库列表', isTab: true}},
        {path: '/facial_info/detail', component: _import('modules/facialInfo/facial_info_detail'), name: 'facial_info_detail', meta: {single:true,title: '人员面部信息详页',parentMenuKey:'/facial_info/list', isTab: true}},

        //第三方对接系统配置列表
        { path: '/thirds_config/list', component: _import('modules/config/thirds_config_list'), name: 'thirds_config_list', meta: {single:true, title: '第三方对接系统配置列表', isTab: true } },
        { path: '/thirds_config/detail', component: _import('modules/config/thirds_config_detail'), name: 'thirds_config_detail', meta: {single:true, title: '第三方对接系统配置详页',parentMenuKey:'/thirds_config/list', isTab: true } },
        { path: '/thirds_config/view', component: _import('modules/config/thirds_config_view'), name: 'thirds_config_view', meta: {single:true, title: '第三方对接系统配置详页',parentMenuKey:'/thirds_config/list', isTab: true } },

        // 评标专家
        {
            path: '/experts-evalBehavior',
            component: _import('modules/experts/evalBehavior'),
            name: 'experts_evalBehavior',
            meta: {single:true, title: '评标专家行为分析', isTab: true}
        },
        // 大数据对接页面
        // 串围标
        {
            path: '/bigData-bidIllegal',
            component: _import('modules/bigData/bigData_bidIllegal'),
            name: 'bigData_bidIllegal',
            meta: {single:true, title: '项目串围标监管', isTab: true}
        },
        {
            path: '/bigData-exception',
            component: _import('modules/bigData/bigData_exception'),
            name: 'bigData_exception',
            meta: {single:true, title: '异常中标率监管', isTab: true}
        },
        // 行业分析
        {
            path: '/industry-environment',
            component: _import('modules/industry/industry_environment'),
            name: 'industry_environment',
            meta: {single:true, title: '营商环境分析', isTab: true}
        },

        // 项目双随机抽取
        // 抽取列表页
        {
            path: '/project_extract/list',
            component: _import('modules/doubleRandom/projectExtract/list'),
            name: 'project_extract_list',
            meta: {single:true, title: '项目双随机收取列表', isTab: true}
        },
        {
            path: '/project_direct_extract',
            component: _import('modules/doubleRandom/projectExtract/dingxiangselect_detail'),
            name: 'project_direct_extract',
            meta: {single:true, title: '项目双随机定向抽取',parentMenuKey:'/project_extract/list', isTab: true}
        },
        {
            path: '/project_extract/result',
            component: _import('modules/doubleRandom/projectExtract/extractResult'),
            name: 'project_extract_result',
            meta: {single:true, title: '随机抽取结果', isTab: true}
        },

        {
            path: '/credit_punish/list',
            component: _import('modules/creditList/punishInfo/list'),
            name:'credit_punish_list',
            meta: {single:true, title: '联合惩戒信息登记', isTab: true}
        },
        {
            path: '/credit_punish/detail',
            component: _import('modules/creditList/punishInfo/detail'),
            name:'credit_punish_detail',
            meta: {single:true, title: '联合惩戒信息登记编辑',parentMenuKey:'/credit_punish/list', isTab: true}
        },
        {
            path: '/credit_punish/view',
            component: _import('modules/creditList/punishInfo/view'),
            name:'credit_punish_view',
            meta: {single:true, title: '联合惩戒信息登记详情',parentMenuKey:'/credit_punish/list', isTab: true}
        },
        {
            path: '/credit_exposal/list',
            component: _import('modules/creditList/exposal/list'),
            name:'credit_exposal_list',
            meta: {single:true, title: '信用红黑榜', isTab: true}
        },

        {
            path: '/credit_exposal/reward_form',
            component: _import('modules/creditList/exposal/rewardInfo/rewardInfoForm'),
            name:'rewardInfoForm',
            meta: {single:true, title: '新增奖励信息',parentMenuKey:'/credit_exposal/list', isTab: true}
        },
        {
            path: '/credit_exposal/reward_view',
            component: _import('modules/creditList/exposal/rewardInfo/rewardInfoView'),
            name:'rewardInfoView',
            meta: {single:true, title: '奖励信息详页',parentMenuKey:'/credit_exposal/list', isTab: true}
        },
        {
            path: '/credit_exposal/illegal_form',
            component: _import('modules/creditList/exposal/violation/violationForm'),
            name:'violationForm',
            meta: {single:true, title: '新增违法违规',parentMenuKey:'/credit_exposal/list',  isTab: true}
        },
        {
            path: '/credit_exposal/illegal_view',
            component: _import('modules/creditList/exposal/violation/violationView'),
            name:'violationView',
            meta: {single:true, title: '违法违规详页',parentMenuKey:'/credit_exposal/list',  isTab: true}
        },
        {
            path: '/credit_exposal/punish_form',
            component: _import('modules/creditList/exposal/sanctio/sanctioForm'),
            name:'sanctioForm',
            meta: {single:true, title: '新增行政处罚',parentMenuKey:'/credit_exposal/list',  isTab: true}
        },
        {
            path: '/credit_exposal/punish_view',
            component: _import('modules/creditList/exposal/sanctio/sanctioView'),
            name:'sanctioView',
            meta: {single:true, title: '行政处罚详页',parentMenuKey:'/credit_exposal/list',  isTab: true}
        },
        {
            path: '/credit_exposal/black_form',
            component: _import('modules/creditList/exposal/black/blackForm'),
            name:'blackForm',
            meta: {single:true, title: '新增黑名单',parentMenuKey:'/credit_exposal/list',  isTab: true}
        },
        {
            path: '/credit_exposal/black_view',
            component: _import('modules/creditList/exposal/black/blackView'),
            name:'blackView',
            meta: {single:true, title: '黑名单详页',parentMenuKey:'/credit_exposal/list',  isTab: true}
        },
        {
            path: '/offline_complaints',
            component: _import('modules/complaintreporting/offline/index'),
            name:'offline_complaints',
            meta: {single:true, title: '线下投诉举报归档', isTab: true}
        },
        {
            path: '/online_complaints/list',
            component: _import('modules/complaintreporting/online/online_complaints'),
            name:'online_complaints_list',
            meta: {single:true, title: '在线投诉举报处理', isTab: true}
        },
        {
            path: '/online_complaints/detail',
            component: _import('modules/complaintreporting/online/detail'),
            name: 'online_complaints_detail',
            meta: {single:true, title: '在线投诉举报处理详情',parentMenuKey:'/online_complaints/list',  isTab: true}
        },
        {
            path: '/online_complaints/exception_detail',
            component: _import('modules/complaintreporting/online/components/exceptiondetail'),
            name: 'online_complaints_exception_detail',
            meta: {single:true, title: '在线投诉举报异常处理详情',parentMenuKey:'/online_complaints/list',  isTab: true}
        },
        // 主体信用监管
        { // 主体列表
            path: '/credit_mainInfo/list',
            component: _import('modules/credit/mainInfo'),
            name: 'credit_mainInfo_list',
            meta: {single:true, title: '主体信用信息监管', isTab: true}
        },
        // 信用评价管理
        { // 信用评价档案 列表
            path: '/credit/archives/list',
            component: _import('modules/credit/archives/list'),
            name: 'credit_archives_list',
            meta: {single:true, title: '信用评价档案列表', isTab: true}
        },
        { // 信用评价档案 详情
            path: '/credit/archives/detail',
            component: _import('modules/credit/archives/detail'),
            name: 'credit_archives_detail',
            meta: {single:true, title: '信用评价档案详情',parentMenuKey:'/credit/archives/list', isTab: true}
        },
        { // 信用评价档案 查看
            path: '/credit/archives/view',
            component: _import('modules/credit/archives/view'),
            name: 'credit_archives_view',
            meta: {single:true, title: '信用评价档案查看',parentMenuKey:'/credit/archives/list', isTab: true}
        },
        { // 信用评价指标
            path: '/credit/Indicators/list',
            component: _import('modules/credit/indicators/list'),
            name: 'credit_Indicators_list',
            meta: {single:true, title: '信用评价指标', isTab: true}
        },
        { // 信用评价方式配置
            path: '/credit/config',
            component: _import('modules/credit/config/index'),
            name: 'creditConfigIndex',
            meta: {single:true, title: '信用评价方式配置', isTab: true}
        },
        { // 评价模型库
            path: '/credit/model',
            component: _import('modules/credit/modelConfig/index'),
            name: 'creditModelIndex',
            meta: {single:true, title: '评价模型库', isTab: true}
        },
        { // 信用报告列表
            path: '/credit/report',
            component: _import('modules/credit/report/list'),
            name: 'creditrReportList',
            meta: {single:true, title: '信用报告列表', isTab: true}
        },
        { // 信用报告详情
            path: '/credit/report/detail',
            component: _import('modules/credit/report/detail'),
            name: 'creditrReportDetail',
            meta: {single:true, title: '信用报告详情', isTab: true}
        },
        { // 项目异常预警 项目叫停
            path: '/project_stop/list',
            component: _import('modules/projectEarlyWarn/project_stop/list'),
            name: 'projectStopList',
            meta: {single:true, title: '项目叫停', isTab: true}
        },
        { // 项目异常预警 项目叫停 详情
            path: '/project_stop/detail',
            component: _import('modules/projectEarlyWarn/project_stop/detail'),
            name: 'projectStopDetail',
            meta: {single:true, title: '新增项目叫停', parentMenuKey:'/project_stop/list',isTab: true}
        },
        { // 项目异常预警 项目暂停/恢复
            path: '/project_puase_recover/list',
            component: _import('modules/projectEarlyWarn/project_puase_recover/list'),
            name: 'projectPuaseRecoverList',
            meta: {single:true, title: '项目暂停/恢复', isTab: true}
        },
        { // 项目异常预警 项目暂停/恢复 详情
            path: '/project_puase_recover/detail',
            component: _import('modules/projectEarlyWarn/project_puase_recover/detail'),
            name: 'projectPuaseRecoverDetail',
            meta: {single:true, title: '新增项目暂停', parentMenuKey:'/project_puase_recover/list',isTab: true}
        },
        { // 服务效能
            path: '/service/config', // 服务效能配置
            component: _import('modules/service/config/index'),
            name: 'service-config',
            meta: {single:true, title: '服务效能配置', isTab: true}
        },
        {
            path: '/service/flow-efficiency/list', // 流程时效可视化
            component: _import('modules/service/flowEfficiency/list'),
            name: 'flow-efficiency-list',
            meta: {single:true, title: '流程时效可视化监管', isTab: true}
        },
        {
            path: '/service/flow-efficiency/detail', // 流程时效可视化详页
            component: _import('modules/service/flowEfficiency/detail'),
            name: 'flow-efficiency-detail',
            meta: {single:true, title: '流程效能监管详页',parentMenuKey:'/service/flow-efficiency/list', isTab: true}
        },
        {
            path: '/service/siteUseRatio/list', // 场地使用效能监管列表
            component: _import('modules/service/siteUse/list'),
            name: 'siteUseRatio-list',
            meta: {single:true, title: '场地使用效能监管列表', isTab: true}
        },
        // 服务效能
        {
            path: '/service/siteUseRatio/detail', // 场地使用效能详页
            component: _import('modules/service/siteUse/detail'),
            name: 'siteUseRatio-detail',
            meta: {single:true, title: '场地使用效能详页',parentMenuKey:'/service/siteUseRatio/list', isTab: true}
        },
        {
            path: '/service/statisticsAnalyse/list', // 服务效能统计分析列表
            component: _import('modules/service/statisticAnalyse/list'),
            name: 'statistics-analyse-list',
            meta: {single:true, title: '服务效能统计分析列表', isTab: true}
        },
        // 服务效能
        // {
        //     path: '/service/statistics-analyse/detail', // 服务效能统计分析详页
        //     component: _import('modules/service/statisticAnalyse/detail'),
        //     name: 'statistics-analyse-detail',
        //     meta: {single:true, title: '服务效能统计分析详页', isTab: true}
        // },
        // 数字监管驾驶舱1
        { path: '/digitCockpit', component: _import('modules/digitCockpit/digitCockpit1'), name: 'digitCockpit', meta: { single:true,title: '数字监管驾驶舱', isTab: true} },
        // 数字监管驾驶舱2
        { path: '/copyDigitCockpit', component: _import('modules/digitCockpit/digitCockpitCopy'), name: 'copyDigitCockpit', meta: { single:true,title: '数字监管驾驶舱2', isTab: true} },
        { path: '/siteMaintenance_config/list', component: _import('modules/site/infoMaintain/list'), name: 'siteMaintenance-configList', meta: { single:true,title: '场地信息维护列表',parentMenuKey:'/siteMaintenance_config', isTab: true} },
        { path: '/siteMaintenance_config', component: _import('modules/site/infoMaintain/index'), name: 'siteMaintenance-config', meta: { single:true,title: '场地信息维护', isTab: true} },
        { path: '/earlyWarning/directory', component: _import('modules/earlyWarning/index'), name: 'earlyWarning-directory', meta: { single:true,title: '预警目录配置', isTab: true} },
        { path: '/earlyWarning/level', component: _import('modules/earlyWarning/level'), name: 'earlyWarning-level', meta: { single:true,title: '预警等级配置', isTab: true} },
        {
            path: '/synthesize/officialDocProcess',
            component: _import('modules/synthesize/officialDocProcess/officialDocProcess_list'),
            name: 'synthesize_officialDocProcess',
            meta: {single:true, title: '公文流转', isTab: true}
        },
        {
            path: '/officialDocProcessForm',
            component: _import('modules/synthesize/officialDocProcess/officialDocProcessForm'),
            name:'officialDocProcessForm',
            meta: {single:true, title: '公文流转详情', parentMenuKey:'/synthesize/officialDocProcess',isTab: true,},
        },
        {
            path: '/officialDocProcessFormChange',
            component: _import('modules/synthesize/officialDocProcess/officialDocProcessFormChange'),
            name:'officialDocProcessFormChange',
            meta: {single:true, title: '公文流转修改', parentMenuKey:'/synthesize/officialDocProcess',isTab: true,}
        },
        {
            path: '/officialDocProcessView',
            component: _import('modules/synthesize/officialDocProcess/officialDocProcessView'),
            name:'officialDocProcessView',
            meta: {single:true, title: '公文流转详页',parentMenuKey:'/synthesize/officialDocProcess', isTab: true}
        },
        {
            path: '/officialDocProcessHistory',
            component: _import('modules/synthesize/officialDocProcess/officialDocProcessHistory'),
            name:'officialDocProcessHistory',
            meta: {single:true, title: '查看历史修改版本',parentMenuKey:'/synthesize/officialDocProcess', isTab: true}
        },
        {
            path: '/synthesize/superviseAndHandle',
            component: _import('modules/synthesize/superviseAndHandle/superviseAndHandle_list'),
            name: 'synthesize_superviseAndHandle',
            meta: {single:true, title: '督察督办', isTab: true}
        },
        {
            path: '/synthesize/superviseAndHandle/sendForm',
            component: _import('modules/synthesize/superviseAndHandle/sendForm'),
            name: 'synthesize_superviseAndHandle_sendForm',
            meta: {single:true, title: '新增督办',parentMenuKey:'/synthesize/superviseAndHandle', isTab: true}
        },
        {
            path: '/synthesize/superviseAndHandle/sendView',
            component: _import('modules/synthesize/superviseAndHandle/sendView'),
            name: 'synthesize_superviseAndHandle_sendView',
            meta: {single:true, title: '督办详情',parentMenuKey:'/synthesize/superviseAndHandle', isTab: true}
        },
        {
            path: '/synthesize/superviseAndHandle/sendEdit',
            component: _import('modules/synthesize/superviseAndHandle/sendEdit'),
            name: 'synthesize_superviseAndHandle_sendEdit',
            meta: {single:true, title: '督办详情',parentMenuKey:'/synthesize/superviseAndHandle', isTab: true}
        },

        // 信用信息
        {
            path: '/portalCreditSystem',
            component: _import('modules/creditInfo/portalCreditSystem/list'),
            name:'portalCreditSystem',
            meta: {single:true, title: '信用制度', isTab: true}
        },
        {
            path: '/portalCreditSystem/add',
            component: _import('modules/creditInfo/portalCreditSystem/edit'),
            name:'portalCreditSystemAdd',
            meta: {single:true, title: '新增信用制度', isTab: true}
        },
        {
            path: '/portalCreditSystem/edit',
            component: _import('modules/creditInfo/portalCreditSystem/edit'),
            name:'portalCreditSystemEdit',
            meta: {single:true, title: '修改信用制度', isTab: true}
        },
        {
            path: '/portalCreditSystem/detail',
            component: _import('modules/creditInfo/portalCreditSystem/detail'),
            name:'portalCreditSystemDetail',
            meta: {single:true, title: '信用制度详情', isTab: true}
        },

        // 行政处罚
        {
            path: '/portalAdministrativePenalties',
            component: _import('modules/creditInfo/portalAdministrativePenalties/list'),
            name:'portalAdministrativePenalties',
            meta: {single:true, title: '行政处罚', isTab: true}
        },
        {
            path: '/portalAdministrativePenalties/add',
            component: _import('modules/creditInfo/portalAdministrativePenalties/edit'),
            name:'portalAdministrativePenaltiesAdd',
            meta: {single:true, title: '新增行政处罚', isTab: true}
        },
        {
            path: '/portalAdministrativePenalties/edit',
            component: _import('modules/creditInfo/portalAdministrativePenalties/edit'),
            name:'portalAdministrativePenaltiesEdit',
            meta: {single:true, title: '修改行政处罚', isTab: true}
        },
        {
            path: '/portalAdministrativePenalties/detail',
            component: _import('modules/creditInfo/portalAdministrativePenalties/detail'),
            name:'portalAdministrativePenaltiesDetail',
            meta: {single:true, title: '行政处罚详情', isTab: true}
        },
        {
            path: '/platformWay',
            component: _import('modules/platformWay/index'),
            name: 'platformWay',
            meta: {single:true, title: '场地安排情况', isTab: true } },

        // 交易数据统计
        {
            path: "/transactionDataStatistics/projectConstruction",
            component: _import("modules/transactionDataStatistics/projectConstruction/index"),
            name: "projectConstruction",
            meta: { single: true, title: "工程建设交易情况", isTab: true },
        },
        {
            path: "/transactionDataStatistics/projectBuildCollect",
            component: _import("modules/transactionDataStatistics/projectBuildCollect/index"),
            name: "projectBuildCollect",
            meta: { single: true, title: "工程建设项目汇总数据", isTab: true },
        },

        // 招标文件检测
        {
            path: '/bidFileCheck/checkList',
            component: _import('modules/bidFileCheck/checkList/index'),
            name: 'cockpit_industry_environment',
            meta: {single:true, title: '招标文件检测', isTab: true}
        },
        //主体责任落实情况
        { path:'/mainResponsibility/list', component: _import('modules/mainResponsibility/index'), name: 'mainResponsibilitylist', meta: {single:true, title: '主体责任落实情况', isTab: true } },
        { path:'/mainResponsibility/detail', component: _import('modules/mainResponsibility/detail'), name: 'mainResponsibilitydetail', meta: {single:true, title: '主体责任落实情况', isTab: true } },
        // 省监管风险预警
        { path: '/thirdparty_warning/list', component: _import('modules/thirdparty/list'), name: 'thirdparty_warning_list', meta: {single:true, title: '省监管风险预警', isTab: true } },
        { path: '/thirdparty_warning/detail', component: _import('modules/thirdparty/detail'), name: 'thirdparty_warning_detail', meta: {single:true, title: '省监管风险预警详页',parentMenuKey:'/thirdparty_warning/list', isTab: true } },

        // 政策法规
        { path: '/laws_regulations/list', component: _import('modules/creditInfo/lawsRegulations/list'), name:'lawsRegulationsList', meta: {single:true, title: '政策法规', isTab: true}},
        { path: '/laws_regulations/edit', component: _import('modules/creditInfo/lawsRegulations/edit'), name:'lawsRegulationsEdit', meta: {single:true, title: '政策法规详页', isTab: true}},
        { path: '/laws_regulations/detail', component: _import('modules/creditInfo/lawsRegulations/detail'), name:'lawsRegulationsDetail', meta: {single:true, title: '政策法规详页', isTab: true}},
        // 信息发布
        { path: '/infomationPublish/list', component: _import('modules/creditInfo/informationPublish/list'), name:'infomationPublishList', meta: {single:true, title: '信息发布', isTab: true}},
        { path: '/infomationPublish/edit', component: _import('modules/creditInfo/informationPublish/edit'), name:'infomationPublishEdit', meta: {single:true, title: '信息发布详页', isTab: true}},
        { path: '/infomationPublish/detail', component: _import('modules/creditInfo/informationPublish/detail'), name:'infomationPublishDetail', meta: {single:true, title: '信息发布详页', isTab: true}},
    ],
    beforeEnter(to, from, next) {
        checkLogin(next)
    }
}
const globalRoutes = [
    {
        path: '/login',
        component: _import('common/huangshiLogin'),
        name: 'login',
        meta: { title: '登录', isTab: false },
        redirect: '/loginForm',
        children: [
            { path: '/loginForm', component: _import('common/huangshiLoginForm'), name: 'loginForm' },
        ]
    },
    {
        path: '/redirect',
        component: _import('common/redirectPage'),
        name: 'redirect',
        meta: { title: '跳转监管', isTab: false },
    },
    {
        path: '/project_extract/detail',
        component: _import('modules/doubleRandom/projectExtract/extractIngDetail'),
        name: 'project_extract_detail',
        meta: {single:true, title: '项目双随机收取详情',}
    },
    {
        path: '/cockpit/index',
        component: _import('modules/cockpit/index'),
        name: 'cockpit',
        meta: {single:true, title: '数智驾驶舱',}
    },
    {
        path: '/cockpit/intelligence/index',
        component: _import('modules/cockpit/intelligence/index'),
        name: 'intelligence_index',
        meta: {single:true, title: '备案监管'}
    },
    {
        path: '/cockpit/legalPerson/index',
        component: _import('modules/cockpit/legalPerson/index'),
        name: 'legalPerson_index',
        meta: {single:true, title: '主体信用监管'}
    },
    {
        path: '/cockpit/service/index',
        component: _import('modules/cockpit/service/index'),
        name: 'service_index',
        meta: {single:true, title: '服务效能监管'}
    },
    // 营商环境分析
    {
        path: '/cockpit/industry-environment',
        component: _import('modules/cockpit/industryEnvironment/index'),
        name: 'cockpit_industry_environment',
        meta: {single:true, title: '营商环境分析'}
    },

]

let proxybaseurl = process.env.VUE_APP_proxybaseurl;
if (!proxybaseurl) {
    proxybaseurl = "";
}
const router = new Router({
    mode: 'history',
    base: proxybaseurl,
    scrollBehavior: () => ({ y: 0 }),
    ssoLoginUrl: '',
    isAddDynamicMenuRoutes: false, // 是否已经添加动态(菜单)路由
    routes: globalRoutes.concat(mainRoutes)
})


/**
 * 动态加载菜单流程
 * 1、判断当前是否加载菜单
 * 2、如果未加载菜单，判断当前是否需要加载动态菜单
 * 3、出现在 globalRoutes 和 skipLoadMenusRoutes 中的路由不需要加载动态菜单。
 */
router.beforeEach((to, from, next) => {
    let currentRouteType = fnCurrentRouteType(to, globalRoutes)
    if (currentRouteType !== 'global') {
        currentRouteType = fnCurrentRouteType(to, skipLoadMenusRoutes)
    }

    if (router.options.isAddDynamicMenuRoutes || (currentRouteType === 'global' && !to.meta.isAuth)) {
        next()
    } else {
        // checkLogin(next)
        let permsPass = false;
        initMenuList(function(result) {
            permsPass = checkPerms(to);
            if(!permsPass)logout();
            if(result && result.code && result.code == '1003'){
                logout()
                return
            }
            if (!result || result.code !== '1') {
                next()
            } else {
                next({...to, replace: true })
            }
        })
    }
})

/**
 * 检查当前路由权限
 * 根据path路径判断当前菜单路由（或者父级路由）是否存在menuList动态路由里
 * @param {*} to 当前路由
 */
function checkPerms(to){
    if(to.path == '/' || to.path == '/home' ){
        return true;
    }
    let menusList =   JSON.parse(sessionStorage.getItem('menuList'));

    let path = to.path;
    // // 项目见证受理详情页,左侧菜单对应父级菜单
    // if(path == "/businessflowWitness/list_detail"){
    //     path = "/businessflowWitness_" + to.query.businessType  + "/list"
    // }
    // // 项目监督记录详情页 左侧菜单对应父级菜单
    // if(path == "/businessWitnessHis/list_detail"){
    //     path = "/businessWitnessHis_" + to.query.businessType + "/list"
    // }
    let obj = recursion(menusList,path);

    if(obj != null){
        return true;
    }else{
        return false;
    }
}
/**
 * 递归查询字路由path参数 是否存在menuList动态路由里
 * 根据path路径判断当前菜单路由（或者父级路由）
 * @param {*} data 路由菜单
 * @param {*} path 当前路由路径
 */
function recursion(data, path) {
    if(!data){
        return;
    }
    // 从 path中拿到菜单目录
    let pathArr = path.split("/");
    let activePathName =pathArr.length>2?pathArr[pathArr.length-2]:(pathArr[1] || pathArr[0]);
    let result = null;

    for(var i in data){
        if(result !== null) {
            break;
        }
        var item = data[i];

        // type == 1 代表菜单地址
        if(item.type == 1){
            let routerUrlArr = item.url.split("/");
            let routerName =routerUrlArr.length>2?routerUrlArr[pathArr.length-2]:( routerUrlArr[1] || routerUrlArr[0] );
            if( routerName == activePathName){
                result = item;
                break;
            }
        }else if(item.children && item.children.length > 0){
            result = recursion(item.children, path);
        }
    }
    return result;
}


/**
 * 判断当前路由类型, global: 全局路由, main: 主入口路由
 * 判断逻辑：
 *    1、如果目标路由的name 或路径 出现在 globalRoutes 参数中
 * @param {*} route 当前路由
 * @param {*} globalRoutes 路由匹配数组
 */
function fnCurrentRouteType(route, globalRoutes = []) {
    var temp = []
    for (var i = 0; i < globalRoutes.length; i++) {
        if (route.path === globalRoutes[i].path || (route.name !== undefined && route.name === globalRoutes[i].name)) {
            return 'global'
        } else if (globalRoutes[i].children && globalRoutes[i].children.length >= 1) {
            temp = temp.concat(globalRoutes[i].children)
        }
    }
    return temp.length >= 1 ? fnCurrentRouteType(route, temp) : 'main'
}
function formatMenuTreeData(data){
    let treeData = [];
    const mapTree = org => {
        const haveChildren = Array.isArray(org.children) && org.children.length > 0;
        org.menuId = org.id;
        org.name = org.text;
        org.children = haveChildren ? org.children.map(i => mapTree(i)) : [];
        return org
    };
    treeData = data.map(org => mapTree(org) );
    return treeData
}
export function initMenuList(callback) {
    if (router.options.isAddDynamicMenuRoutes === true) {
        if (callback !== undefined) {
            callback()
        }
        return
    }
    httpRequest.post('/loadMenus/supervision',{},{baseURL:baseURL}).then(({ data }) => {
        if(data && data.code && data.code == '1003'){
            logout(false)
            return
        }
        let formatData = formatMenuTreeData(data);
        fnAddDynamicMenuRoutes(formatData)
        router.options.isAddDynamicMenuRoutes = true
        sessionStorage.setItem('menuList', JSON.stringify(formatData || '[]'))
        sessionStorage.setItem('leftMenuList', JSON.stringify(formatData[0] || {}))
        sessionStorage.setItem('topActiveMenuId', (formatData[0] && formatData[0].name) || 'home')
        if (callback !== undefined) {
            callback(formatData)
        }
    }).catch((e) => {
        console.log(`%c${e} 请求菜单列表和权限失败，跳转至登录页！！`, 'color:blue')
        sessionStorage.setItem('menuList', '[]')
        sessionStorage.setItem('permissions', '[]')
        router.push({ name: 'error' })
    })
}

/**
 * 添加动态(菜单)路由
 * @param {*} menuList 菜单列表
 * @param {*} routes 递归创建的动态(菜单)路由
 */
function fnAddDynamicMenuRoutes(menuList = []) {
    let routes = []
    fnAddDynamicMenuRoutesCicle(menuList, routes)
    mainRoutes.name = 'main-dynamic'
    mainRoutes.children = routes
    router.addRoutes([
        mainRoutes,
        { path: '*', redirect: { name: '404' } }
    ])
    sessionStorage.setItem('dynamicMenuRoutes', JSON.stringify(mainRoutes.children || '[]'))
    console.log('\n')
    console.log('%c!<-------------------- 动态(菜单)路由 s -------------------->', 'color:blue')
    console.log(mainRoutes.children)
    console.log('%c!<-------------------- 动态(菜单)路由 e -------------------->', 'color:blue')
}

/**
 * 添加动态(菜单)路由
 * @param {*} menuList 菜单列表
 * @param {*} routes 递归创建的动态(菜单)路由
 */
function fnAddDynamicMenuRoutesCicle(menuList = [], routes = []) {
    var temp = []
    let funcList = []
    for (var i = 0; i < menuList.length; i++) {
        let menuItem = menuList[i]
        if (menuItem.children && menuItem.children.length >= 1) {
            temp = temp.concat(menuItem.children)
        } else if (menuItem.url && /\S/.test(menuItem.url)) {
            if (menuItem.funcList && menuItem.funcList.length >= 1) {
                funcList = funcList.concat(menuItem.funcList)
            }
            //有明确路由名称的表示静态路由
            if (menuItem.routeName) {
                continue
            }
            menuItem.url = menuItem.url.replace(/^\//, '')
            let url = menuItem.url
            let argIndex = url.indexOf('?')
            if (argIndex > 0) {
                url = url.substr(0, argIndex)
            }
            let routePath = url.replace('/', '-')
            var route = {
                    path: routePath,
                    component: null,
                    name: routePath,
                    meta: {
                        menuId: menuItem.id,
                        title: menuItem.text,
                        isDynamic: true,
                        isTab: true,
                        iframeUrl: ''
                    }
                }
                // url以http[s]://开头, 通过iframe展示
            if (isURL(menuItem.url)) {
                route['path'] = `i-${menuItem.id}`
                route['name'] = `i-${menuItem.id}`
                route['meta']['iframeUrl'] = menuItem.url
            } else {
                try {
                    route['component'] = _import(`modules/${url}`) || null
                } catch (e) {}
            }
            routes.push(route)
        }
    }
    if (temp.length >= 1) {
        fnAddDynamicMenuRoutesCicle(temp, routes)
    }
    if (funcList.length >= 1) {
        fnAddDynamicMenuRoutesCicle(funcList, routes)
    }
}

export default router
